"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var context_1 = require("./context");
function FirebaseProvider(props) {
    var value = props.value, children = props.children;
    return React.createElement(context_1.default.Provider, { value: value }, children);
}
exports.default = FirebaseProvider;
//# sourceMappingURL=firebase-provider.js.map